import { render, staticRenderFns } from "./antwerpen.vue?vue&type=template&id=5ff6ac96"
import script from "./antwerpen.vue?vue&type=script&lang=js"
export * from "./antwerpen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports